// Keep this enum synced with the same enum class in C# on the backed
export enum GenericOperationStatuses {
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  NotAllowed = "NotAllowed",
  Completed = "Completed",
  PartiallyCompleted = "PartiallyCompleted",
  Failed = "Failed",
  Forbidden = "Forbidden",
  Cancelled = "Cancelled",
  NotFound = "NotFound",
  Conflict = "Conflict",
  Unauthorized = "Unauthorized",
  BadRequest = "BadRequest",
  FeatureIsNotAvailable = "FeatureIsNotAvailable"
}
